<section>
  <div class="row">
    <div class="col-md-12">
      <div class="padB12 clearfix">
        <div class="float-left">
          <h3 class="h3Header candidate" name="candidateheading">
            <strong>Candidates</strong>
          </h3>
        </div>
        <div class="float-right line">
          <div class="displayInline">
            <mat-label>
              <span class="mainBodyTxt3 inline marR8 GreyLight" name="candshowby">Show by</span>
            </mat-label>
            <mat-form-field id="canActId">
              <mat-select [(value)]="selectedActivity" (selectionChange)="filterChange($event.value)">
                <mat-option *ngFor="let item of activity | keyvalue" [value]="item.value">
                  {{ item.value }}
                </mat-option>
              </mat-select> </mat-form-field
            >&nbsp;
            <span class="marT24">
              <a href="javascript:void(0)">
                <img
                  src="assets/images/icons/default_icons/icon-filter.png"
                  alt="icon-filter"
                  [matMenuTriggerFor]="menu"
                  width="20px"
                  height="20px"
                  name="iconfilter"
                />
              </a>
            </span>
          </div>

          <mat-menu #menu="matMenu" class="custom-menu" name="menu">
            <mat-card appearance="outlined">
              <mat-card-title name="filterHead"> Filter By </mat-card-title>
              <div *ngIf="sourceFlag">
                <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
                  <mat-expansion-panel id="canSrcId">
                    <mat-expansion-panel-header name="sourcehead"> Source </mat-expansion-panel-header>
                    <div *ngFor="let item of sourceDisplay">
                      <mat-checkbox (change)="checkSource(item)" name="sourcecheckbox">
                        {{ item }}
                      </mat-checkbox>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div *ngIf="technologyFlag">
                <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
                  <mat-expansion-panel id="canSkillId">
                    <mat-expansion-panel-header name="technologyHead"> Technology </mat-expansion-panel-header>
                    <div *ngFor="let skill of skillDisplay">
                      <mat-checkbox (change)="checkTechnology(skill)" name="skillcheckbox">
                        {{ skill }}
                      </mat-checkbox>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </mat-card>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="customCard nomarT">
  <div class="row">
    <div class="col-md-3 col-12">
      <candidate-list
        [dataSourceToChild]="tempCandidateList"
        [selectFirstCandidate]="selectFirstCandidate"
        (profileData)="getProfileData($event)"
      >
      </candidate-list>
    </div>
    <div class="col-md-9 col-12" *ngIf="selectedCandidate">
      <div class="marB16">
        <candidate-profile
          [profileData]="candidateBasicDetails"
          [candAppIds]="candAppIds"
          [activityList]="activities"
          [requisitionId]="this.selectedCandidate[0].requisitionId"
          [rolePass]="this.roleCode"
        ></candidate-profile>
      </div>
      <!-- <div *ngIf="!correspondenceFlag && !rejectionFlag && !scheduleFlag"> -->
      <div *ngFor="let item of groupedActivities | keyvalue" class="row">
        <div class="text-center col-md-4 offset-md-4 marB8 marT16">
          <h2 class="h2Header" name="dateheader">{{ item.key | date: 'd LLL yyy' }}</h2>
        </div>
        <div *ngFor="let activity of item.value; let i = index" class="col-12">
          <div class="customActivityCard">
            <span>
              <h3 name="activityDesc" class="h3Header inline GreyLight activitydescription marL4">
                {{ activity.activityDescription }}
              </h3>
              <span class="float-right">
                <!-- <span class="activity-data-letters float-left marR16">{{activity.modifiedBy| initials}}</span> -->
                <p class="mainBodyTxt2 inline GreyLight marL4">{{ activity.modifiedBy }}</p>
                <p class="mainBodyTxt2 inline GreyLight marL8">
                  {{ activity.modifiedOn | date: 'd LLL' }}
                </p>
                <!-- <button class="Icon-Btn mat-icon-button mat-button-base" name="deletebtn{{i}}" mat-icon-button="" *ngIf="activity.editflag" (click)="deleteActivityCard(activity)">
                                        <span class="mat-button-wrapper">
    
                                            <img alt="icon-delete-mini" id="deleteImg{{i}}" src="assets/images/icons/purple_icons/icon-delete-mini.png">
                                        </span>
                                        <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple="">
                                        </div>
                                        <div class="mat-button-focus-overlay">
                                        </div>
                                    </button> -->
                <button
                  class="Icon-Btn mat-icon-button mat-button-base"
                  mat-icon-button=""
                  name="editbtn{{ i }}"
                  *ngIf="activity.editflag == true"
                  (click)="editactivity(activity)"
                >
                  <span class="mat-button-wrapper">
                    <img alt="icon-edit" id="editImg{{ i }}" src="assets/images/icons/purple_icons/icon-edit.png" />
                  </span>
                  <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""></div>
                  <div class="mat-button-focus-overlay"></div>
                </button>

                <!-- <p class="mainBodyTxt2 inline GreyLight marL8" (click)="editActivity(activity)">edit</p> -->
                <!-- <p class="mainBodyTxt2 inline GreyLight marL8" *ngIf="activity.editflag" (click)="editActivity(activity)">edit</p> -->
              </span>
            </span>
          </div>
        </div>
      </div>
      <div>
        <app-activity-dialog
          *ngIf="editactivityflag"
          [editcandidateApplicationIds]="candidateApplicationIds"
          [ifCoupled]="ifCoupled"
          [interviewFlag]="interviewFlag"
          [editcheckSuitabilityDataObj]="editcheckSuitabilityDataObj"
          [selectedCandidate]="selectedCandidate"
          [editcheckInterviewDataObj]="editcheckInterviewDataObj"
          [editcheckCorrespondenceDataObj]="editcheckCorrespondenceDataObj"
          [editcheckHrPanelInterviewObj]="editcheckHrPanelInterviewObj"
          [editcheckStatusChangeDataObj]="editcheckStatusChangeDataObj"
          [coupledEditCheckSuitabilityDataObj2]="coupledEditCheckSuitabilityDataObj2"
          [coupledEditCheckSuitabilityDataObj1]="coupledEditCheckSuitabilityDataObj1"
          [onCoupledSuitability]="coupledOnSuitabilityEdit"
          [onSuitability]="onSuitabilityEdit"
          [coupledEditCheckCorrespondenceDataObj2]="coupledEditCheckCorrespondenceDataObj2"
          [coupledEditCheckCorrespondenceDataObj1]="coupledEditCheckCorrespondenceDataObj1"
          [onCoupledCorrespondence]="coupledOnCorrespondenceEdit"
          [onCorrespondence]="onCorrespondenceEdit"
          [coupledEditCheckInterviewDataObj2]="coupledEditCheckInterviewDataObj2"
          [coupledEditCheckInterviewDataObj1]="coupledEditCheckInterviewDataObj1"
          [onCoupledInterviewSchedule]="coupledOnInterviewScheduleEdit"
          [onInterviewSchedule]="onInterviewScheduleEdit"
          [coupledEditCheckStatusChangeDataObj2]="coupledEditCheckStatusChangeDataObj2"
          [coupledEditCheckStatusChangeDataObj1]="coupledEditCheckStatusChangeDataObj1"
          [onCoupledStatusChangeSchedule]="coupledOnStatusChangeScheduleEdit"
          [onStatusChangeSchedule]="onStatusChangeScheduleEdit"
          [coupledEditCheckHrPanelInterviewObj2]="coupledEditCheckHrPanelInterviewObj2"
          [coupledEditCheckHrPanelInterviewObj1]="coupledEditCheckHrPanelInterviewObj1"
          [onCoupledHrPanelInterview]="coupledEditHrPanelInterview"
          [onHrPanelInterview]="onHrPanelInterviewEdit"
          [candidateEmails]="candidateEmails"
          [selectedCandidate]="selectedCandidate"
          [resetFlag]="resetFlag()"
        ></app-activity-dialog>
      </div>
      <!-- </div> -->

      <!-- <div *ngIf="correspondenceFlag" class="marT16">
                <div class="text-center col-4 offset-4 marB8 marTB16">
                   
                </div>
                <correspondence [correspondenceDataObj]="correspondenceObj" (uploadedFiles)="receivedFile($event)"
                    (cancelClicked)="cancelCorrespondenceTrigger()">
                </correspondence>
            </div>

            <div *ngIf="rejectionFlag" class="marT16">
                <div class="text-center col-4 offset-4 marB8 marTB16">
                </div>
               
                <app-rejection [rejectionDataObj]="rejectionObj" [selectedEvent] = "selectedEvent" (cancelClicked)="cancelRejectionTrigger()" (rejectClicked)="rejectTrigger($event)"></app-rejection>
            </div>
            <div *ngIf="scheduleFlag" class="marT16">
                <div class="text-center col-4 offset-4 marB8 marTB16">
                    <h3 class="h3Header">{{selectedCandidate.dateCreated  | date:'d LLL'}}</h3>
                </div>
                <app-reschedule [rescheduleDataObj]="scheduleObj"></app-reschedule>
            </div> -->

      <!-- activity integration-->
      <div *ngIf="selectedCandidate && activityState">
        <div *ngIf="onSuitability" class="activityCard">
          <activity-check-suitability
            [selectedCand]="selectedCandidate"
            [checkSuitabilityDataObj]="checkSuitabilityDataObj"
            [candidateApplicationIds]="candidateApplicationIds"
            (refreshcandiates)="callrefreshcandiates($event)"
          ></activity-check-suitability>
        </div>
        <div *ngIf="onCorrespondence" class="activityCard">
          <activity-correspondence
            [correspondenceDataObj]="correspondenceDataObj"
            [candidateEmails]="candidateEmails"
            [candidateApplicationIds]="candidateApplicationIds"
            [selectedCandidate]="selectedCandidate"
            (refreshcandiates)="callrefreshcandiates($event)"
          ></activity-correspondence>
        </div>
        <div *ngIf="onInterviewSchedule" class="activityCard">
          <activity-scheduleinterview
            [interviewFlag]="interviewFlag"
            [checkInterviewSchDataObj]="checkInterviewSchDataObj"
            [candidateEmails]="candidateEmails"
            [selectedCandidate]="selectedCandidate"
            [candidateApplicationIds]="candidateApplicationIds"
            (refreshcandiates)="callrefreshcandiates($event)"
          ></activity-scheduleinterview>
        </div>
        <div *ngIf="onStatusChangeSchedule" class="activityCard">
          <activity-status-change
            [checkStatusChangeObj]="checkStatusChangeObj"
            [candidateApplicationIds]="candidateApplicationIds"
            [candidateObj]="selectedCandidate"
            (refreshcandiates)="callrefreshcandiates($event)"
          ></activity-status-change>
        </div>
        <div *ngIf="onHrPanelInterview" class="activityCard">
          <app-activity-hrinterview
            [checkHrPanelInterviewObj]="checkHrPanelInterviewObj"
            [candidateApplicationIds]="candidateApplicationIds"
            (refreshcandiates)="callrefreshcandiates($event)"
          ></app-activity-hrinterview>
        </div>

        <div *ngIf="ifCoupled" class="activityCard">
          <app-coupled-activity
            [checkSuitabilityDataObj]="coupledCheckSuitabilityDataObj"
            [correspondenceDataObj]="couplledCorrespondenceDataObj"
            [candidateEmails]="candidateEmails"
            [interviewFlag]="interviewFlag"
            [checkInterviewSchDataObj]="coupledCheckInterviewSchDataObj"
            [checkStatusChangeObj]="coupledCheckStatusChangeObj"
            [onSuitability]="coupledOnSuitability"
            [onCorrespondence]="coupledOnCorrespondence"
            [onInterviewSchedule]="coupledOnInterviewSchedule"
            [onStatusChangeSchedule]="coupledOnStatusChangeSchedule"
            [coupledcheckSuitabilityDataObj]="coupled2CheckSuitabilityDataObj"
            [coupledcorrespondenceDataObj]="couplled2CorrespondenceDataObj"
            [coupledcheckInterviewSchDataObj]="coupled2CheckInterviewSchDataObj"
            [coupledcheckStatusChangeObj]="coupled2CheckStatusChangeObj"
            [onCoupledSuitability]="coupled2OnSuitability"
            [onCoupledCorrespondence]="coupled2OnCorrespondence"
            [onCoupledInterviewSchedule]="coupled2OnInterviewSchedule"
            [onCoupledStatusChangeSchedule]="coupled2OnStatusChangeSchedule"
            [selectedCandidate]="selectedCandidate"
            [candidateApplicationIds]="candidateApplicationIds"
            [checkHrPanelInterviewObj]="coupledcheckHrPanelInterviewObj"
            [onHrPanelInterview]="coupledhrpanelInterview"
            [coupledcheckHrPanelInterviewObj]="coupled2checkHrPanelInterviewObj"
            [onCoupledHrPanelInterview]="coupled2hrpanelInterview"
            [ifCoupled]="ifCoupled"
            (refreshcandiates)="callrefreshcandiates($event)"
          ></app-coupled-activity>
          <!-- <app-coupled-activity [test]="true" [CheckSuitabilityDataObj]="coupledCheckSuitabilityDataObj"
                
                ></app-coupled-activity> -->
        </div>
      </div>
      <!-- activity integ -->

      <div class="marT16 footer">
        <span class="messagebox">
          <ul>
            <li class="active clearfix">
              <span class="messagebox-container">
                <span class="data-letters float-left marR4 message-img-size" name="loginusrname">{{
                  loginUserName | initials
                }}</span>

                <div class="messagebox-formfield relative">
                  <input name="messages" placeholder="Write messages down here..." class="messagebox-input" />
                  <a
                    href="javascript:void(0)"
                    class="messagebox-icon iconinline icon x-24 transform45 marT18 send-icon"
                  ></a>
                </div>
                <span class="marT24">
                  <a href="javascript:void(0)">
                    <img
                      src="assets/images/icons/default_icons/icon-services.png"
                      alt="icon-services"
                      id="serviceBtnId"
                      [matMenuTriggerFor]="activityMenu"
                      #trigger="matMenuTrigger"
                      width="20px"
                      height="20px"
                      (click)="setActivityState()"
                    />
                  </a>
                  <img
                    src="assets/images/icons/default_icons/icon-attachment.png"
                    alt="icon-attachment"
                    class="pointer"
                    width="20px"
                    height="20px"
                  />
                </span>
              </span>
            </li>
          </ul>
        </span>
      </div>
    </div>
  </div>
  <mat-menu #activityMenu="matMenu" class="custom-menu" yPosition="above" xPosition="before" name="mmenu">
    <!-- <ul class="listItemSingle" *ngFor="let item of activityList">
            <li>
                <button mat-flat-button id="button" name="button" class="btn text-left btnclr btnblock GreyDarkest"
                    (click)="displayService(item)">
                    <strong>{{item.activityDescription}}</strong>
                </button>
            </li>
        </ul> -->
    <!-- activity part starts-->
    <app-activity-footer
      [selectedCandidate]="selectedCandidate"
      [processTypeList]="processActivityList"
      [processStage]="processStage"
      *ngIf="selectedCandidate"
      (customScreeningEvent)="updateScreenProcess($event)"
      (customPreScreeningEvent)="updatePreScreenProcess($event)"
      (customInterviewEvent)="updateInterviewProcess($event)"
      (ROAEvent)="updateROA($event)"
      (correspondenceCheckEvent)="updateCorrespondence($event)"
      (suitabiltyCheckEvent)="updateSuitability($event)"
      (statusEvent)="updateStatusChange($event)"
      (interviewCheckEvent)="updateInterviewSchedule($event)"
      (updateactivityselected)="clearActivityObj()"
      (hrPanelUpdateEvent)="updateHrPanelChange($event)"
      (coupledInterviewCheckEvent)="updateInterviewScheduleCoupled($event)"
      (coupledSuitabiltyCheckEvent)="updateSuitabilityCoupled($event)"
      (coupledhrPanelUpdateEvent)="updateHrPanelChangeCoupled($event)"
      (coupledCorrespondenceCheckEvent)="updateCorrespondenceCoupled($event)"
      (coupledStatusEvent)="updateStatusChangeCoupled($event)"
      (coupled2InterviewCheckEvent)="updateInterviewScheduleCoupled2($event)"
      (coupled2SuitabiltyCheckEvent)="updateSuitabilityCoupled2($event)"
      (coupled2hrPanelUpdateEvent)="updateHrPanelChangeCoupled2($event)"
      (coupled2CorrespondenceCheckEvent)="updateCorrespondenceCoupled2($event)"
      (coupled2StatusEvent)="updateStatusChangeCoupled2($event)"
      (hrPanelUpdateEvent)="updateHrPanelChange($event)"
      (updateifcoupled)="updateifcoupled($event)"
    >
    </app-activity-footer>

    <!-- activity part ends -->
  </mat-menu>
</div>
